import { useGeneralAppStore } from "../store/generalAppStore";
import { useAxiosError } from "./axios/useAxiosError";
import { useNotificadoresStore } from "../store/notificadoresStore";
import { useAbortController } from "./useAbortController";
import { axios } from "../utils/axios";
import { toast } from "react-toastify";
import { toastOptions } from "../config/toast";

export const useNotificadores = () => {
  const signal = useAbortController();

  //~ HOOKS
  const { handleAxiosError } = useAxiosError();

  //? ESTADOS GLOABALES
  const { handlerLoading } = useGeneralAppStore();
  const { setNotificadores } = useNotificadoresStore();

  //TODO TRAE TODO LOS NOTIFICADORES
  const getNotificadores = async () => {
    handlerLoading({ loading: true, loadName: "fetch_notificadores" });
    try {
      const response = await axios().get('get_notificadores');
      const { data, error } = response.data;
      if (data) setNotificadores(data)
      if (error) toast.error(error, toastOptions);
    } catch (error) {
      handleAxiosError(error);
    } finally {
      handlerLoading({ loading: false, loadName: "fetch_notificadores" });
    }
  };


  return { getNotificadores };
};
